import { Row, Col, Typography, Modal } from 'antd';
import React from 'react';
import PartWrapper from 'mixins/ui/part-wrapper';
import Button from 'mixins/ui/button/button';
import BackIcon from 'icons/back-icon.svg';
import { localize } from '/react4xp/mixins/helpers';

const Theme = (props: any) => {
    const handleCancel = () => {
        Modal.info({
            icon: null,
            content: (
                <PartWrapper
                    language={props.language}
                    isError={false}
                >
                    <Row>
                        <Col>
                            <span>
                                {localize('oprosy-question-want-leave-page', props.translations)}
                            </span>
                        </Col>
                    </Row>
                    <hr className="my-3" />
                    <Row
                        justify="space-between"
                        className="mt-3"
                    >
                        <Col>
                            <Button
                                onClick={() => {
                                    props.setStep('MAIN');
                                    Modal.destroyAll();
                                }}
                            >
                                {localize('button.leave-page', props.commonTranslations)}
                            </Button>
                        </Col>
                        <Col>
                            <Button
                                color="gold"
                                type="primary"
                                onClick={() => Modal.destroyAll()}
                            >
                                {localize('button.to-stay', props.commonTranslations)}
                            </Button>
                        </Col>
                    </Row>
                </PartWrapper>
            ),
            footer: null,
        });
    };

    return (
        <Row
            gutter={[48, { md: 16 }]}
            className="questionnaire-theme mb-3"
        >
            <Col>
                <BackIcon
                    onClick={
                        props.status && props.status === 'ACTIVE'
                            ? handleCancel
                            : () => props.setStep('MAIN')
                    }
                    className="back-icon"
                />
            </Col>
            <Col>
                <Typography.Title
                    className="questionnaire-theme__title"
                    level={3}
                >
                    {props.theme}
                </Typography.Title>
            </Col>
            <Col>
                <span className="questionnaire-theme__anonymity-status">
                    {props.anonymity === true ? localize('oprosy-anonymous', props.translations) : localize('oprosy-not-anonymous', props.translations)}
                </span>
            </Col>
        </Row>
    );
};

export default Theme;
